var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"analytics account-analytics"},[_c('filter-bar',{attrs:{"timeframe":_vm.timeframe},on:{"change":_vm.setTimeframe}}),_c('stats',{attrs:{"data":_vm.basicMetrics,"props":_vm.basicMetricProps,"min-width":_vm.minWidth}}),(_vm.dimensions && _vm.treemapItems)?_c('treemap',{attrs:{"items":_vm.treemapItems,"width":_vm.dimensions.width,"height":800,"min-width":_vm.minWidth,"type":'user'}}):_vm._e(),(_vm.readership && _vm.timeframeLabels && _vm.dimensions)?_c('line-chart',{attrs:{"items":_vm.readership,"timeframe-labels":_vm.timeframeLabels,"width":_vm.dimensions.width,"height":400,"min-width":_vm.minWidth,"timeframe":_vm.timeframe}}):_vm._e(),_c('ranking-list',{attrs:{"title":"Top Articles","items":(_vm.cogData ? _vm.cogData.topArticlesByTimeframe[_vm.timeframe] : []).map(
        function (tr) { return ({
          id: tr.articleId,
          name: tr.article ? tr.article.title : '-',
          value: tr.views,
          lastValue: 0,
          diffNum: false,
          diffStr: '',
          webDownloads: tr.downloads || 0,
          emailViews: 0,
          sendgridOpened: 0,
          valueRank: 1,
          lastValueRank: -1,
          change: 0,
          engagement: 4,
          position: 1,
          account: '',
          account_id: 0,
          channel: tr.article ? tr.article.channel : '-',
          channel_id: tr.article ? tr.article.channelId : '-',
          analyst: tr.article ? tr.article.primaryAnalyst || '-' : '-',
          analyst_id: tr.article ? tr.article.analystIds[0] : '-',
          companies: null,
          email: '',
        }); }
      ),"active-id":_vm.data.id,"settings":_vm.topListTypes['accountArticle'],"client-width":_vm.clientWidth}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }